import {
  UPDATE_ORDER_ADDRESSES_REQUEST,
  UPDATE_ORDER_ADDRESSES_SUCCESS,
  UPDATE_ORDER_ADDRESSES_ERROR,
} from '~gatsby-theme-autonomy/redux/actions/types'
import { getOrLoadCart } from './get-or-load-cart'

export const updateOrderAddressesRequest = () => {
  return {
    type: UPDATE_ORDER_ADDRESSES_REQUEST,
  }
}

export const updateOrderAddressesSuccess = (cart) => {
  return {
    type: UPDATE_ORDER_ADDRESSES_SUCCESS,
    data: cart,
  }
}

export const updateOrderAddressesError = (error) => {
  return {
    type: UPDATE_ORDER_ADDRESSES_ERROR,
    error: true,
    payload: error,
  }
}

export const updateOrderAddresses =
  (shipAddressAttributes) =>
  async (dispatch, getState, { api }) => {
    try {
      dispatch(updateOrderAddressesRequest())

      const { data: cart } = await getOrLoadCart(dispatch, getState)
      await api.updateOrderAddresses(cart, shipAddressAttributes)

      const updatedCart = await api.fetchCart(cart.number)
      dispatch(updateOrderAddressesSuccess(updatedCart))
    } catch (error) {
      dispatch(updateOrderAddressesError(error))
      throw error
    }
  }
